import { useCallback, useState } from 'react';

export function useIdSelection() {
  const [selected, setSelected] = useState(() => new Set());

  const toggle = useCallback((id, on) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (on) next.add(id);
      else next.delete(id);
      return next;
    });
  }, []);

  const setAll = useCallback((ids, on) => {
    setSelected(() => (on ? new Set(ids) : new Set()));
  }, []);

  const clear = useCallback(() => setSelected(new Set()), []);

  return { selected, toggle, setAll, clear, count: selected.size };
}
